import { Api, theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Avatar, Button, Clickable, Col, Icon, Row, Text } from 'components';

const SideBarItem = ({ item, follow, navigate, subtitleText, removeSuggestion, allUsers }) => {
  const [loading, setLoading] = useState(false),
    { following } = useSelector((state) => state.user) || {},
    isFollowing = following?.find((x) => (x?._id || x) === item?._id),
    dispatch = useDispatch(),
    { t } = useTranslation();

  subtitleText =
    typeof subtitleText === typeof (() => null) ? subtitleText(item) : subtitleText || item?.bio;

  if (!item) return null;

  async function follow() {
    if (loading) return;
    setLoading(true);

    const res = await Api.post(
      isFollowing ? '/users/unfollow' : '/users/follow',
      { userId: item._id },
      `suggestionsFollow${item._id}`
    );
    if (!res) return;

    console.log({ action: isFollowing ? '/users/unfollow' : '/users/follow', res, item });

    dispatch({
      type: isFollowing ? 'UNFOLLOW' : 'FOLLOW',
      payload: item?._id || item
    });

    setLoading(false);
  }

  return (
    <Col marg="0 0 16px" wid="100%">
      <Row between>
        <Row hasFlex start>
          <Clickable onClick={() => navigate(`/profile/${item.username}`)}>
            <Row centerAll>
              <Avatar user={item} />

              <Col marg="0 0 0 8px" center noFlex wid="100%">
                <Text b1 bold>
                  {item.name}
                </Text>

                {!!subtitleText?.length && (
                  <Text
                    c1
                    med
                    col={theme.GREY_60}
                    wid="160px"
                    ht="18px"
                    hideOverflow
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                  >
                    {subtitleText}
                  </Text>
                )}
              </Col>
            </Row>
          </Clickable>
        </Row>

        <Col center noFlex>
          <Row ht="100%" center noFlex>
            <Button
              app
              wid="104px"
              text={isFollowing ? t('common.unfollow') : t('common.follow')}
              small
              textColor="#000"
              bg="rgba(210, 216, 223, 0.7)"
              onClick={() => follow(item)}
              action={`suggestionsFollow${item._id}`}
            />

            {!allUsers && (
              <Clickable onClick={() => removeSuggestion(item)} marg="0 0 0 8px">
                <Row wid="32px" ht="32px" hasRadius="16px" bg="rgba(210, 216, 223, 0.7)" centerAll>
                  <Icon type="close" col="#000" dimensions={14} />
                </Row>
              </Clickable>
            )}
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default SideBarItem;
